<template>
  <v-sheet class="clip">
    <resizable-page>
      <template #header>
        <div class="clip_title">
          <span
            v-if="!isTagSearch"
            class="clip_title_text clip_title_text--active"
            >ビデオクリップ一覧</span
          >
          <template v-else>
            <span
              class="clip_title_text clip_title_text-pointer"
              @click="handleFirstTab"
              >ビデオクリップ一覧</span
            >
            <img
              src="@/assets/icons/ico_next.svg"
              class="clip_title_icon"
              alt=""
            />
            <span
              class="clip_title_text clip_title_text--active text-break--custom"
            >
              {{ currentTag.name }}</span
            >
            <span
              v-ripple
              class="icon icon-pencil"
              @click="handleRename"
            ></span>
          </template>
        </div>
      </template>
      <template #filter>
        <!--        <section-->
        <!--          v-if="!isTagSearch && clipTags.length > 0"-->
        <!--          class="clip_tabs-wrapper"-->
        <!--        >-->
        <!--          <v-tabs-->
        <!--            v-model="tabs"-->
        <!--            height="26px"-->
        <!--            centered-->
        <!--            dense-->
        <!--            :hide-slider="true"-->
        <!--            class="clip_tabs"-->
        <!--            active-class="clip_tabs-active"-->
        <!--          >-->
        <!--            <v-tab-->
        <!--              v-for="(item, index) in tabItems"-->
        <!--              :key="index"-->
        <!--              @change="handleTab(item.index)"-->
        <!--            >-->
        <!--              {{ item.label }}-->
        <!--            </v-tab>-->
        <!--          </v-tabs>-->
        <!--        </section>-->
        <div class="clip_filter-wrapper">
          <clip-filter
            v-if="tabs !== 1"
            ref="clipFilter"
            :options="{
              hideSearch: isTagSearch,
              hideCreate: true,
            }"
            :total="totalCount"
            :total-filtered="totalCountFiltered"
            :selected-clips="selectedClips"
            @refreshSelectedClips="selectedClips = []"
            @search="handleSearch"
            @onMove="handleMove"
            @onDownload="handleDownload"
            @onDelete="dialogDeleteOpen = true"
            @clipToolsOpenChange="clipToolsOpen = $event"
            @goTab="handleTab"
          />
        </div>
      </template>
      <template #table="tableProps">
        <clip-folder
          v-if="tabs === 1"
          :height="tableProps.bodyHeight"
          @onCreate="handleCreate"
        />
        <div v-else class="clip_container">
          <app-skeleton
            :loading="loadingClips && videoClips.length === 0"
            :nodata="videoClips.length === 0"
            nodata-text="該当するビデオクリップはありません"
            skeleton="homeEvents"
          />
          <v-data-table
            v-model="selectedClips"
            :headers="headers"
            :items="videoClips"
            hide-default-footer
            disable-pagination
            :height="tableProps.bodyHeight"
            item-key="index"
            sort-by="dateTime"
            class=""
            :fixed-header="true"
          >
            <template #top>
              <!-- Download dialog -->
              <clip-dialog-a
                :open="dialogDownloadOpen"
                title="ダウンロード"
                @onClose="closeDialogDownload"
              >
                <div class="clip_dialog-content">
                  {{ selectedClips.length }}件のデータを
                  <br />選択してダウンロードします。
                </div>
                <template #actions>
                  <v-btn
                    class="clip_dialog-btn clip_dialog-cancel"
                    color="text"
                    :disabled="downloading"
                    @click="closeDialogDownload"
                  >
                    キャンセル
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    class="clip_dialog-btn clip_dialog-ok"
                    color="primary"
                    :loading="downloading"
                    @click="handleDownloadOk()"
                  >
                    ダウンロード
                  </v-btn>
                </template>
              </clip-dialog-a>
              <!-- Delete dialog -->
              <clip-dialog-a
                :open="dialogDeleteOpen"
                title="削除"
                @onClose="closeDialogDelete"
              >
                <div class="clip_dialog-content">
                  {{ selectedClips.length }}件のデータを<br />
                  完全に削除してもよろしいですか？
                </div>
                <template #actions>
                  <v-btn
                    class="clip_dialog-btn clip_dialog-cancel"
                    color="text"
                    @click="closeDialogDelete"
                  >
                    キャンセル
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    class="clip_dialog-btn clip_dialog-delete"
                    color="text"
                    @click="handleDeleteOk"
                  >
                    削除する
                  </v-btn>
                </template>
              </clip-dialog-a>
              <!-- ----------------- -->
              <!-- Message dialog -->
              <clip-dialog-message
                :open="!!dialogMessageText"
                :message="dialogMessageText"
                @onClose="closeDialogMessage"
              />
              <!-- ----------------- -->
            </template>
            <template #[`body.append`]>
              <tr class="clip-infinit_scroll">
                <td colspan="7">
                  <infinite-loading
                    ref="infinitScroll"
                    spinner="spiral"
                    force-use-infinite-wrapper=".v-data-table__wrapper"
                    @infinite="loadMoreClips"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">
                      <h3 v-if="videoClips.length === 0">
                        データはありません。
                      </h3>
                    </div>
                  </infinite-loading>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <tr style="visibility: hidden" />
            </template>

            <!-- Table body template  -->
            <template #item="{ item, isSelected, select }">
              <tr
                class="clip_row"
                :class="isSelected ? 'selected' : ''"
                @click="toggleSelect(item, isSelected, select, $event)"
              >
                <td v-if="item.status === 2" class="text-start">
                  <v-img
                    v-if="item.thumbnailUrl"
                    :src="item.thumbnailUrl"
                    class="clip_tbl-img"
                    height="66px"
                    min-width="117px"
                    max-width="117px"
                  >
                    <div v-if="isSelected" class="clip_select-icon">
                      <span class="icon icon-check" />
                    </div>
                  </v-img>
                  <no-image
                    v-else
                    width="117px"
                    height="66px"
                    color="rgba(0, 0, 0, 0.5)"
                  >
                    <div v-if="isSelected" class="clip_select-icon">
                      <span class="icon icon-check" />
                    </div>
                  </no-image>
                </td>
                <td v-else class="text-start">
                  <pending-clip>
                    <div v-if="isSelected" class="clip_select-icon">
                      <span class="icon icon-check" />
                    </div>
                  </pending-clip>
                </td>
                <td class="text-start text-break--custom pt-2 pb-2">
                  {{ item.clipName }}
                </td>
                <td class="text-center">
                  <span class="clip_tbl-dateTime">
                    {{ item.startDate | dateMs('YYYY/MM/DD', 'unix') }} </span
                  ><br />
                  <span class="clip_tbl-dateTime">
                    {{ item.startDate | dateMs('HH:mm:ss', 'unix') }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="clip_tbl-duration"> {{ item.duration }} </span>
                </td>
                <td class="text-start">
                  <event-label v-if="!!item.event" :label="item.event" />
                </td>
                <td class="text-start">
                  <span class="clip_tbl-cameraName">
                    {{
                      cameraById[item.cameraId] !== undefined
                        ? cameraById[item.cameraId].name
                        : ''
                    }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="clip_tbl-dateTime">
                    {{ item.createDate | dateMs('YYYY/MM/DD', 'unix') }} </span
                  ><br />
                  <span class="clip_tbl-dateTime">
                    {{ item.createDate | dateMs('HH:mm:ss', 'unix') }}
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </template>
    </resizable-page>
    <!-- Rename dialog -->
    <clip-input-dialog
      v-if="isTagSearch"
      title="名前を変更する"
      :loading="loadingRename"
      :open="dialogRenameOpen"
      :name="currentTag.name"
      :maxlength="100"
      :input-case="'clipName'"
      @onClose="closeDialogRename"
      @onOk="handleRenameOk"
    />
    <!-- Create tag dialog -->
    <clip-input-dialog
      :loading="loadingCreate"
      :open="dialogCreateOpen"
      title="フォルダを作成する"
      ok-label="作成"
      @onClose="closeDialogCreate"
      @onOk="handleCreateOk"
    />
    <!-- Move to tag dialog -->
    <clip-move-dialog
      :loading="loadingMove"
      :open="dialogMoveOpen"
      :list="moveList"
      title="フォルダを移動する"
      ok-label="移動"
      @onClose="closeDialogMove"
      @onOk="handleMoveOk"
    />
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ClipFilter from './ClipFilter.vue';
import ClipDialogA from '../../components/dialogs/ClipDialogA.vue';
import ClipDialogMessage from '../../components/dialogs/ClipDialogMessage.vue';
import InfiniteLoading from 'vue-infinite-loading';
import {
  deleteVideoClips,
  downloadVideoClips,
  setVideoClip,
} from '@/services/video-clip.service';
import { MimeTypes } from '@/globals/enums';
import { STORAGE_KEYS } from '@/constants/storage';
import { downloadVideoClipsSequentially } from '@/utils/file';
import { dialogService } from '@/services/dialog.service';
import ClipFolder from './ClipFolder.vue';
import ClipInputDialog from '@/components/dialogs/ClipInputDialog.vue';
import { uuidv4 } from '@/utils/helpers';
import StorageService from '@/services/StorageService';
import ClipMoveDialog from '@/components/dialogs/ClipMoveDialog.vue';
import CameraService from '@/services/CameraService';

export default {
  name: 'Clip',
  components: {
    ClipFilter,
    ClipDialogA,
    ClipDialogMessage,
    InfiniteLoading,
    ClipFolder,
    ClipInputDialog,
    ClipMoveDialog,
  },
  data: () => ({
    totalCount: 0,
    totalCountFiltered: 0,
    getClipsReqId: null,
    loadingRename: false,
    loadingCreate: false,
    loadingMove: false,
    dialogRenameOpen: false,
    dialogCreateOpen: false,
    dialogMoveOpen: false,
    mimeTypes: MimeTypes,
    dialogDownloadOpen: false,
    dialogDeleteOpen: false,
    dialogMessageText: null,
    downloading: false,
    loadingClips: false,
    headers: [
      {
        text: 'サムネイル画像',
        value: 'thumbnailUrl',
        align: 'left custom-pl-26',
        sortable: false,
      },
      {
        text: 'ビデオクリップ名称',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: '時刻', value: 'startDate', align: 'center', sortable: false },
      { text: '記録時間', value: 'duration', align: 'center', sortable: false },
      { text: 'イベント', value: 'event', sortable: false },
      { text: 'カメラ名称', value: 'cameraName', sortable: false },
      {
        text: '更新日時',
        value: 'createDate',
        align: 'center',
        sortable: false,
      },
    ],
    tabs: 0,
    tabItems: [
      {
        label: '全てのビデオクリップ',
        value: 'all',
        index: 0,
      },
      {
        label: 'フォルダ',
        value: 'folder',
        index: 1,
      },
    ],
    editedIndex: -1,
    editedItem: {
      name: '',
      startDate: 0,
      duration: 0,
      event: 0,
      cameraName: 0,
    },
    defaultItem: {
      name: '',
      startDate: 0,
      duration: 0,
      event: 0,
      cameraName: 0,
    },
    selectedClips: [],
    clipToolsOpen: false,
    limit: 50,
    searchFilterParams: {},
    infinitScrollState: null,
    currentOffset: 0,
    downloadedFiles: [],
  }),
  computed: {
    ...mapGetters('common', {
      currentGroupCamList: 'currentGroupCamList',
    }),
    ...mapState({
      videoClips: (state) =>
        state.video.videoClips.map((item, index) => ({ ...item, index })),
      cameraList: (state) => state.common.cameraList,
      searchKeys: (state) => state.common.searchKeys,
      cameraById: (state) => state.common.cameraById,
      clipTags: (state) => state.video.clipTags,
      searchParams: (state) => state.video.searchParams,
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    canUserAccess() {
      return this.isCurrentAvatarOwner || !this.currentCameraPolicy.liveOnly;
    },
    isTagSearch() {
      return !!this.currentTag;
    },
    tagId() {
      return this.$route.query.tag;
    },
    currentTag() {
      return this.tagId && this.clipTags.length > 0
        ? this.clipTags.find((tag) => String(tag.id) === String(this.tagId))
        : null;
    },
    moveList() {
      const list = [{ label: 'フォルダに入れない', id: 0 }];
      this.clipTags.forEach((tag) => {
        list.push({
          label: tag.name,
          id: tag.id,
        });
      });
      return list;
    },
  },

  watch: {
    canUserAccess(val) {
      if (!val) {
        this.routerPush({ name: 'home' });
      }
    },
    '$route.query': {
      handler: function (to, from) {
        if (to.tab !== from.tab || to.tag !== from.tag) {
          this.handleQueryChange(to, from);
        }
      },
      deep: true,
    },
    tabs() {
      this.selectedClips = [];
      if (this.$refs.clipFilter) {
        this.$refs.clipFilter.filterOpen = false;
        this.$refs.clipFilter.clipToolsOpen = false;
      }
      this.clipToolsOpen = false;
    },
    dialogDownloadOpen(val) {
      val || this.closeDialogDownload();
    },
    dialogDeleteOpen(val) {
      val || this.closeDialogDelete();
    },
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
    currentGroupCamList() {
      this.init();
      this.handleQueryChange();
    },
  },
  beforeDestroy() {
    this.resetSearch();
  },
  mounted() {
    this.init();
    this.handleQueryChange();
  },
  methods: {
    ...mapActions('video', [
      'fetchVideoClips',
      'resetSearchClips',
      'fetchClipTags',
      'setClipList',
      'createTag',
      'updateVideoClip',
      'moveToTag',
      'checkEmptyTagToDelete',
      'updateTag',
      'setSearchParams',
    ]),
    ...mapActions('common', ['abortHttpRequest']),
    async init() {
      if (!this.canUserAccess) {
        this.resetSearch();
        return;
      }
      CameraService.saveClipListPosition(-1);
      this.setSearchParams(null);
      await this.fetchTags();
    },
    resetSearch({ shouldResetTotal = true } = {}) {
      this.resetSearchClips();
      if (shouldResetTotal) {
        this.totalCount = 0;
      }
      this.totalCountFiltered = 0;
    },
    async fetchTags() {
      try {
        this.loading = true;
        await this.fetchClipTags();
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleQueryChange(to) {
      if (!this.canUserAccess) {
        return;
      }
      if (!to || !to.tab || Number(to.tab) === 0) {
        this.resetSearch();
        this.tabs = 0;
        let tagIds = '';
        if (to && to.tag) {
          tagIds = `${to.tag}`;
        }
        this.handleSearch({ tagIds });
      }
    },
    async handleFirstTab() {
      this.abortGetClipsRquest();
      await this.delayPromise(100);
      this.routerReplace({ query: null });
    },
    closeDialogRename() {
      this.dialogRenameOpen = false;
    },
    handleRename() {
      this.dialogRenameOpen = true;
    },
    async handleRenameOk(name) {
      try {
        this.loadingRename = true;
        await this.updateTag({ ...this.currentTag, name });
        this.dialogRenameOpen = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingRename = false;
      }
    },
    closeDialogCreate() {
      this.dialogCreateOpen = false;
    },
    handleCreate() {
      this.dialogCreateOpen = true;
    },
    async handleCreateOk(name) {
      try {
        this.loadingCreate = true;
        await this.createTag({
          tag: {
            name,
          },
          clips: [],
        });
        await this.fetchClipTags();
        this.dialogCreateOpen = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingCreate = false;
      }
    },
    closeDialogMove() {
      this.dialogMoveOpen = false;
    },
    handleMove() {
      this.dialogMoveOpen = true;
    },
    async handleMoveOk(tagId) {
      try {
        this.loadingMove = true;
        await this.moveToTag({
          clips: this.selectedClips,
          tagId,
        });
        this.selectedClips = [];
        if (this.isTagSearch) {
          this.handleQueryChange(this.$route.query);
        }
        this.dialogMoveOpen = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingMove = false;
      }
    },
    handleTab(tab) {
      if (Number(tab) === 1) {
        this.resetSearch();
        this.abortGetClipsRquest();
      }
      this.routerReplace({ query: { tab } });
    },
    handleDownload() {
      this.dialogDownloadOpen = true;
    },
    handleSearch(filterParams) {
      this.searchFilterParams = filterParams;
      this.currentOffset = 0;
      if (this.$refs.infinitScroll && this.$refs.infinitScroll.stateChanger) {
        this.$refs.infinitScroll.stateChanger.reset();
      }
      this.resetSearch({ shouldResetTotal: !filterParams.__isFiltered });
    },
    async loadMoreClips($state) {
      if (!this.canUserAccess) {
        this.$refs?.infinitScroll?.stateChanger &&
          this.$refs.infinitScroll.stateChanger.complete();
        this.resetSearch();
        return;
      }
      this.loadingClips = true;
      this.infinitScrollState = $state;
      const hasMore = await this.getClips();
      if (hasMore) {
        this.currentOffset += this.limit;
        this.$refs?.infinitScroll?.stateChanger &&
          this.$refs.infinitScroll.stateChanger.loaded();
      } else {
        this.$refs?.infinitScroll?.stateChanger &&
          this.$refs.infinitScroll.stateChanger.complete();
      }
      this.loadingClips = false;
    },
    async getClips() {
      this.abortGetClipsRquest();
      const searchParams = {
        upperLimit: this.limit,
        offset: this.currentOffset,
        tagIds: [],
        ...this.searchFilterParams,
      };

      delete searchParams.__isFiltered;

      if (!searchParams.cameraIds) {
        searchParams.cameraIds = this.currentGroupCamList
          .map((cam) => cam.id)
          .join(',');
      }
      if (this.$route.query.tag) {
        searchParams.tagIds = [this.$route.query.tag];
      }
      StorageService.setItem(
        STORAGE_KEYS.LastVideoClipsSearchParams,
        searchParams
      );
      this.getClipsReqId = uuidv4().replaceAll('-', '');
      Object.setPrototypeOf(searchParams, { __reqId: this.getClipsReqId });
      this.setSearchParams(searchParams);
      const { hasMore, total } = await this.fetchVideoClips(searchParams);

      if (!this.searchFilterParams.__isFiltered) {
        this.totalCount = total;
      }
      this.totalCountFiltered = total;
      return hasMore;
    },
    abortGetClipsRquest() {
      if (this.getClipsReqId) {
        this.abortHttpRequest(this.getClipsReqId);
      }
    },
    async handleDownloadOk() {
      this.downloading = true;
      this.downloadedFiles = [];
      try {
        this.closeDialogDownload();
        this.dialogMessageText = 'ダウンロードを開始しました。';

        this.downloadedFiles = await downloadVideoClipsSequentially(
          this.selectedClips,
          downloadVideoClips
        );

        if (this.downloadedFiles.length === 0) {
          this.showDownloadErrorDialog();
        } else {
          this.downloading = false;
        }
      } catch (error) {
        console.log(error);
        this.showDownloadErrorDialog();
      } finally {
        this.downloading = false;
      }
    },
    showDownloadErrorDialog() {
      this.downloading = false;
      this.closeDialogDownload();
      dialogService.showErrorDialog(
        {
          title: ' ',
          content: `ビデオクリップ準備中のため<br>
              ダウンロードできませんでした。<br>
              お手数ですが、時間をおいて再度お試しください。`,
          cancel: false,
        },
        {
          classes: ['height-245'],
        }
      );
    },
    async handleDeleteOk() {
      try {
        await deleteVideoClips({
          ids: this.selectedClips.map((clip) => clip.id),
        });
        this.selectedClips = [];
        this.closeDialogDelete();
        this.dialogMessageText = 'データを削除しました';

        this.$refs.clipFilter.handleSearch(true);
      } catch (error) {
        console.error(error);
      } finally {
        this.load;
      }
    },
    toggleSelect(item, isSelected, select) {
      if (item.disabled) {
        return;
      }
      if (this.clipToolsOpen) {
        select(!isSelected);
      } else {
        CameraService.saveClipListPosition(item.offset);
        setVideoClip(item);
        const tag = (item.tags && item.tags[0]?.id) || this.$route.query.tag;
        this.$router.push({
          name: 'clip-detail',
          params: { id: item.id, tag, fromClipPage: true },
        });
      }
    },
    closeDialogDownload() {
      this.dialogDownloadOpen = false;
    },
    closeDialogDelete() {
      this.dialogDeleteOpen = false;
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.clip {
  flex-grow: 1;
  .icon-pencil {
    margin-left: 10px;
    color: #989898;
    font-size: 16px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .pendingClip {
    margin: 10px;
  }
  &_folder {
    &-update {
      margin-bottom: 5px;
      span {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.92;
        letter-spacing: normal;
        text-align: right;
        color: #999;
      }
    }
  }
  &-infinit_scroll {
    text-align: center;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    &-img {
      margin: 10px;
    }
    &-dateTime {
      font-size: 14px;
      font-weight: 600;
      color: #666;
      text-align: center;
    }
    &-duration {
      font-size: 14px;
      font-weight: 600;
      color: #666;
    }
    &-event {
      padding: 0 5px 2px;
      border-radius: 3px;
      background-color: #fcc800;
      font-size: 12px;
      font-weight: 500;
      color: #4b4b4b;
      font-family: 'Noto Sans JP', sans-serif;
    }
    &-cameraName {
      font-size: 14px;
      color: #666;
      font-weight: normal;
      font-family: 'Noto Sans JP', sans-serif;
    }
  }
  th {
    vertical-align: bottom;
    span {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
    &.custom-pl-26 {
      padding-left: 26px !important;
    }
  }
  td {
    vertical-align: middle;
    max-width: 75px;
    .noThumbnailImage {
      margin: 10px;
    }
    &.custom-pl-26,
    &:first-child {
      padding-left: 26px;
    }
  }
  tr {
    cursor: pointer;
  }
  tr.selected {
    background-color: #f3f3f3 !important;
    border-color: #f3f3f3 !important;
  }
  tr.v-data-table__empty-wrapper {
    display: none;
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_title {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    color: var(--text-color);
    justify-content: flex-start;
    &_text {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.14;
      &--active {
        font-weight: bold;
      }
      &-pointer {
        cursor: pointer;
        min-width: 130px;
      }
    }
    &_icon {
      margin: 0 5px;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_container {
    position: relative;
  }
  .v-btn {
    margin-top: 10px;
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }

  &_dialog {
    position: relative;
    &-cancel {
      color: #666 !important;
    }
    &-delete {
      color: #eb545b !important;
    }
    &-btn {
      width: 120px;
      font-size: 14px !important;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    }
    &-content {
      margin: 20px 0;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
  }
  &_tabs {
    width: 337px;

    .v-slide-group__content.v-tabs-bar__content {
      border-radius: 5px;
      background-color: #eee;
      padding: 2px 0;
    }
    .v-tab {
      font-size: 13px;
      width: 166px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: normal;
      text-align: left;
    }
    &-active {
      border-radius: 5px;
      background-color: #fff;
      color: #0075c2;
    }
    &-wrapper {
      position: relative;
      margin: 15px 0;
      width: 342px;
      height: 25px;
    }
  }
  &_filter-wrapper {
    .clipFilter_cams {
      max-height: 110px !important;
      overflow-y: auto !important;
    }
  }
}
</style>
